import { Controller } from 'react-hook-form';
import Input from 'src/components/Input/Input';
import React from 'react';

export const WorkflowNameAndDescriptionBlock = ({ control, isCustom = true }) => {
  return (
    <div className={'flex flex-col gap-2.5'}>
      <div>
        <p className={'text-sm text-ebony_opacity_80 font-semibold'}>Name and description</p>
      </div>
      <div>
        <Controller
          control={control}
          name="name"
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <Input
              type={'text'}
              className={'!px-3.5 !py-3 read-only:!bg-[#a498ff1a]'}
              label={'Workflow name*'}
              placeholder={'Workflow name'}
              invalidMessage={error?.message}
              value={value}
              isValid={!error?.message}
              onChange={onChange}
              readonly={!isCustom}
            />
          )}
        />
      </div>
      <div>
        <Controller
          control={control}
          name="description"
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <Input
              type={'text'}
              className={'!px-3.5 !py-3 read-only:!bg-[#a498ff1a]'}
              label={'Workflow description'}
              placeholder={'Workflow description'}
              invalidMessage={error?.message}
              value={value}
              isValid={!error?.message}
              onChange={onChange}
              readonly={!isCustom}
            />
          )}
        />
      </div>
    </div>
  );
};
